"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAemConfigurationContextWrapper = exports.AemConfigurationContext = void 0;
const react_1 = require("react");
exports.AemConfigurationContext = (0, react_1.createContext)({});
const useAemConfigurationContextWrapper = () => (0, react_1.useContext)(exports.AemConfigurationContext);
exports.useAemConfigurationContextWrapper = useAemConfigurationContextWrapper;
//# sourceMappingURL=AemConfigurationContext.js.map